module.exports = __webpack_public_path__ + "built-mockup@2x.38tAnEeP.png";